import React, { useId, useState, useEffect } from "react";
import { connect } from "react-redux";
import { NavBarOptions } from "./NavBarOptions";
import Text from "../Common/Text";
import Colors from "../../themes/Colors";
import {
  MenuNavbar,
  Menu,
  MenuItem,
  DropdownMenu,
  DropdownMenuItem,
} from "./HeaderStyles";
import CustomButton from "../CustomButton/CustomButton";
import useEmpresa from "../../hooks/useEmpresa";
import CheckRender from "../Common/CheckRender";
import { getStandVirtualFullUrl } from "../../containers/autorizacion/utils/AutorizacionUtils";
import { PROGRAMA, EMPRESA } from "../../utils/Constant";
import { useLocation } from "react-router-dom";

const NavOptionRender = ({
  title,
  submenu,
  hasSubmenu,
  redirectTo,
  isStandVirtual,
  isPyp,
  isCc,
  color,
  hoverColor,
  tokenStandVirtual,
  isSelected,
  onClick,
}) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const goToPath = (option) => {
    window.location.href = option.redirectTo;
  };

  const onClickSingleOption = () => {
    if (isStandVirtual) {
      const newTab = window.open(
        getStandVirtualFullUrl(tokenStandVirtual),
        "_blank"
      );
      newTab.focus();
      return;
    }

    if (isPyp) {
      window.location.href = redirectTo + "?program=" + PROGRAMA.PROMOCION_PREVENCION.CODIGO;
      return;
    }

    if (isCc) {
      window.location.href = redirectTo + "?program=" + PROGRAMA.CRONICO_COMPLEJO.CODIGO;
      onClick();
      return;
    }

    window.location.href = redirectTo;
  };

  const id = useId();
  const empresa = useEmpresa();

  return (
    <MenuItem>
      <CustomButton
        label={title}
        weight={"bold"}
        onClick={hasSubmenu ? toggleDropdown : onClickSingleOption}
        bgColor={isSelected ? empresa?.COLOR_SECUNDARIO : color}
        hoverColor={hoverColor}
      />

      {hasSubmenu && (
        <DropdownMenu isOpen={isDropdownOpen}>
          {submenu?.map((item, index) => (
            <DropdownMenuItem
              key={`${id}-${index}`}
              onClick={() => goToPath(item)}
              backGroundHover={empresa?.COLOR_PRINCIPAL}
            >
              <Text size="15px" color={Colors.primaryPrimera} hoverColor={Colors.white}>
                {item?.subtitle}
              </Text>
            </DropdownMenuItem>
          ))}
        </DropdownMenu>
      )}
    </MenuItem>
  );
};

const CustomMenuNavBar = (props) => {
  const location = useLocation();
  const id = useId();
  const empresa = useEmpresa();
  const isPrimera = empresa?.CODIGO === EMPRESA.PRIMERA.CODIGO;
  const { isStandVirtual, tokenStandVirtual, prestador } = props?.authUserData;
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("program") === PROGRAMA.CRONICO_COMPLEJO.CODIGO) {
      const ccOption = NavBarOptions.find((item) => item.isCc);
      if (ccOption) {
        setSelectedOption(ccOption.key);
      }
    } else {
      const authOption = NavBarOptions.find((item) => item.title === "Autorizaciones");
      if (authOption) {
        setSelectedOption(authOption.key);
      }
    }
  }, [location.search]);

  const getButtonColor = () => {
    return empresa?.COLOR_PRINCIPAL;
  };

  const getHoverColor = () => {
    return empresa?.COLOR_SECUNDARIO;
  };

  const showOption = (item) => {
    return (
      (!item?.isStandVirtual && !item.isPyp && !item.isCc) ||
      (item.isStandVirtual && isStandVirtual) ||
      (item.isPyp && prestador.pyp && isPrimera) ||
      (item.isCc && prestador.cronicoComplejo && isPrimera)
    );
  };

  const handleOptionClick = (key) => {
    setSelectedOption(key);
  };

  return (
    <MenuNavbar>
      <Menu>
        {NavBarOptions.map((item, index) => (
          <CheckRender key={`${id}-${index}`} allowed={showOption(item)}>
            <NavOptionRender
              tokenStandVirtual={tokenStandVirtual}
              title={item?.title}
              submenu={item?.submenu}
              hasSubmenu={item?.hasSubmenu}
              redirectTo={item?.redirectTo}
              isStandVirtual={item?.isStandVirtual}
              isPyp={item?.isPyp}
              isCc={item?.isCc}
              color={getButtonColor()}
              hoverColor={getHoverColor()}
              isSelected={selectedOption === item.key}
              onClick={() => handleOptionClick(item.key)}
            />
          </CheckRender>
        ))}
      </Menu>
    </MenuNavbar>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(CustomMenuNavBar);